import React, { useState, useEffect } from 'react'
import "./CustomDatatableInstitution.css";
import { FaPencilAlt } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import ReactPaginate from 'react-paginate';
import { useNavigate } from 'react-router-dom';
import { BiEdit } from "react-icons/bi"
import Pagination from '../Pagination/Pagination';
import { useDispatch, useSelector, shallowEqual } from "react-redux";


const CustomDatatableInstitution = (props) => {

    const { columns, data,
        changePage,
        pageCount,
        pageNumber,
        perPage } = props;
    const dispatch = useDispatch();


    const [processOngoing, setProcessOngoing] = useState(false)

    const navigate = useNavigate();

    const states = useSelector((state) => state, shallowEqual);

    return (
        <>
            <div className="table-responsive ">
                <table className="table table-striped dataTable w-100">
                    <thead className="">
                        <tr role={"row"}>
                            {columns && columns.map((item, index) =>
                                <th className="text-left pl-5" >
                                    {item.label}</th>
                            )}
                            <th className="text-center w-30">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length !== 0 ? data?.map((item, index) =>
                            <tr key={index+"wcdi"}>

                                <td className="text-left pl-5">{pageNumber > 1 ? (perPage * (pageNumber - 1) + (index + 1)) : (index + 1)}</td>
                                <td className="text-left pl-5">
                                    {item?.libelle}
                                </td>
                                <td className="text-left pl-5">
                                    {item?.category_institution.libelle}
                                </td>
                                <td className="text-left pl-5">
                                    {item?.email}
                                </td>
                                <td className="text-left pl-5">
                                    {item?.telephone}
                                </td>

                                <td className="text-center pl-5">
                                    {/* Start */}
                                    {Object.keys(item.zones).length > 2 &&
                                        <ul>

                                            <li>
                                                <span className="badge badge-warning m-1">{item.zones[0].libelle}</span>

                                            </li>
                                            <li>
                                                <span className="badge badge-warning m-1">{item.zones[1].libelle}</span>

                                            </li>
                                            <li>
                                                ...
                                            </li>
                                        </ul>}
                                    {Object.keys(item.zones).length == 2 &&
                                        <ul>
                                            <li>
                                                <span className="badge badge-warning m-1">{item.zones[0].libelle}</span>

                                            </li>
                                            <li>
                                                <span className="badge badge-warning m-1">{item.zones[1].libelle}</span>

                                            </li>
                                        </ul>}
                                    {Object.keys(item.zones).length == 1 &&
                                        <ul>
                                            <li>
                                                <span className="badge badge-warning m-1">{item.zones[0].libelle}</span>

                                            </li>

                                        </ul>}
                                    {Object.keys(item.zones).length == 0 &&
                                        <ul>
                                            <li>
                                                <span className="badge badge-dark m-1">Aucune zone</span>
                                            </li>
                                        </ul>
                                    }

                                    {/* End */}
                                    {/* {item?.zones.map(zone => <span className="badge badge-warning m-1">{zone.libelle}</span>)} */}
                                    {/* {item?.zones.length === 0 && <span className="badge badge-dark m-1">Aucune zone</span>} */}
                                </td>

                                <td className="">
                                    <BiEdit onClick={() => navigate(`/institution/${item?.id}`)} title="Modifier" style={{ fill: "#2196F3", height: 25, width: 30, padding: 2, cursor: "pointer" }} className="custom-edit-button mr-1" />
                                </td>
                            </tr>
                        ) : <h1 className="ok"></h1>}
                    </tbody>
                </table>
                <Pagination pageCount={pageCount} changePage={changePage} />
            </div>
        </>
    )
}

export default CustomDatatableInstitution

